import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CircularIndicator from '../common/indicators/circularIndicator';
import utilFunction from '../../containers/function';
import $ from 'jquery';

const TravelsTable = props => (
  <section className="travels-table">
    <table>
      <thead>
        <tr>
          <th className="travels-table-th col0-th" ></th>
          <th className="travels-table-th col1-th" />
          <th className="travels-table-th col2-th" ></th> 
          <th className="travels-table-th col3-th" />
        </tr>
      </thead>
      <tbody>
        {props.data &&
          props.data.map((item, i) => (
            <tr
              id={`t-travels-table-${i}`}
              className="travel-row"
              key={`t-travels-table-${i}`}
              onClick={function(_idRow, _idTravel, _handleTravelClick, obj) {
                $('.travels-table .travel-row.active').removeClass('active');
                $('#' + _idRow).addClass('active');
                _handleTravelClick(_idTravel);
              }.bind(
                null,
                `t-travels-table-${i}`,
                'tripId=' + item.tripId + '&behaviourId=' + item.behaviorModelId,
                props.handleTravelClick
              )}
            >
              <td className="travels-table-td col0-td">
                <div className="time timeEnd">
                  {utilFunction.getFormatFunction({
                    type: 'DATE_TIME_PARSE_ISO',
                    format: '%I:%M %p'
                  })(item.endDate)}
                </div>
                <div className="date dateEnd">
                  {utilFunction.getFormatFunction({
                    type: 'DATE_TIME_PARSE_ISO',
                    format: '%d/%m/%Y'
                  })(item.endDate)}
                </div>
                <div className="date dateInit">
                  {utilFunction.getFormatFunction({
                    type: 'DATE_TIME_PARSE_ISO',
                    format: '%d/%m/%Y'
                  })(item.startDate)}
                </div>
                <div className="time timeInit">
                  {utilFunction.getFormatFunction({
                    type: 'DATE_TIME_PARSE_ISO',
                    format: '%I:%M %p'
                  })(item.startDate)}
                </div>
              </td>
              <td className="travels-table-td col1-td">
                <div className="place placeEnd">{item.destinationGeoZone}</div>
                <div className="plate">
                  {props.team}: {item.vehicleAlias}
                </div>
                <div className="place placeInit">{item.sourceGeoZone}</div>
              </td>
              <td className="travels-table-td col2-td">
                <CircularIndicator
                  size={60}
                  max={100}
                  value={item.tripBehaviorGrade}
                  fontSize={'15px'}
                  thickness={4}
                  valueFormat={{ type: 'NUMBER', format: '.0f' }}
                  graphColorRange={props.graphColorRange}
                />
              </td>
              <td className="travels-table-td col3-td">
                <div className="indicator indicatorKm">
                  <span>
                    {utilFunction.getFormatFunction({ type: 'NUMBER', format: '.1f' })(
                      item.amountDrivenKm
                    )}{' '}
                    Km
                  </span>
                </div>
                <div className="indicator indicatorDur">
                  <span>
                    {utilFunction.getFormatFunction({ type: 'NUMBER', format: 'hh:mm' })(
                      item.amountDrivenHours
                    )}
                  </span>
                </div>
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  </section>
);

export default TravelsTable;



// WEBPACK FOOTER //
// ./source/client/components/driver_behavior/travelsTable.jsx